module.exports = __webpack_public_path__ + "ath_game_web/img/6.2.2f540ee8.png";